import { render, staticRenderFns } from "./GraficoICM.vue?vue&type=template&id=673b6ddc&scoped=true"
import script from "./GraficoICM.vue?vue&type=script&lang=js"
export * from "./GraficoICM.vue?vue&type=script&lang=js"
import style0 from "./GraficoICM.vue?vue&type=style&index=0&id=673b6ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b6ddc",
  null
  
)

export default component.exports